// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"e913aa26","135":"fa27b3f5","651":"384978ed","749":"1e7f8ea5"}[chunkId] + ".chunk.js";
};